import React from 'react';

/**
 * Reusable property group wrapper
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PropertyGroup = _ref => {
  let {
    label,
    children,
    className = 'property-group'
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [label && /*#__PURE__*/_jsx("label", {
      children: label
    }), children]
  });
};